(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      //if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  if (!customElements.get('ra-cart-page-recommendations')) {
    customElements.define('ra-cart-page-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.raInitialized) return;
        this.raInitialized = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-ra-add-variant]');
          if (button && this.contains(button)) this.addItem(button);
        });
      }
      async addItem(button) {
        if (this.busy) return;
        this.busy = true;
        this.querySelectorAll('[data-ra-add-variant]').forEach(el => { el.disabled = true; });
        button.setAttribute('aria-busy', 'true');
        const status = this.querySelector('.ra-page-rec-status');
        status.textContent = '';
        let added = false;
        try {
          const sectionId = this.dataset.sectionId;
          const body = {
            items: [{ id: button.dataset.raAddVariant, quantity: Number(button.dataset.quantity) || 1 }],
            sections: [sectionId, 'cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          };
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          const html = result.sections && result.sections[sectionId];
          if (!html) throw new Error(this.dataset.refreshError);
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const sourceItems = parsed.querySelector('#main-cart-items .js-contents');
          const targetItems = document.querySelector('#main-cart-items .js-contents');
          const sourceFooter = parsed.querySelector('#main-cart-footer .cart__footer');
          const targetFooter = document.querySelector('#main-cart-footer .cart__footer');
          if (!sourceItems || !targetItems || !sourceFooter || !targetFooter) throw new Error(this.dataset.refreshError);
          targetItems.innerHTML = sourceItems.innerHTML;
          targetFooter.innerHTML = sourceFooter.innerHTML;
          const sourceShipping = parsed.querySelector('#main-cart-shipping .js-contents-shipping');
          const targetShipping = document.querySelector('#main-cart-shipping .js-contents-shipping');
          if (sourceShipping && targetShipping) targetShipping.innerHTML = sourceShipping.innerHTML;
          const iconHtml = result.sections['cart-icon-bubble'];
          const icon = document.getElementById('cart-icon-bubble');
          if (iconHtml && icon) {
            const source = new DOMParser().parseFromString(iconHtml, 'text/html').querySelector('.shopify-section');
            if (source) icon.innerHTML = source.innerHTML;
          }
          const drawer = document.querySelector('cart-drawer');
          if (drawer && result.sections['cart-drawer']) {
            const source = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer .drawer__inner');
            const target = drawer.querySelector('#CartDrawer .drawer__inner');
            if (source && target) { target.innerHTML = source.innerHTML; drawer.classList.remove('is-empty'); }
          }
          const live = document.getElementById('cart-live-region-text');
          if (live) live.textContent = this.dataset.success;
          const heading = document.getElementById('RaPageRecommendationsHeading');
          if (heading) heading.focus({ preventScroll: true });
          document.dispatchEvent(new CustomEvent('variant:add', { detail: {
            variant: { id: button.dataset.raAddVariant }, quantity: Number(button.dataset.quantity) || 1,
            sectionId: sectionId
          }}));
          // Existing theme/app listeners receive the current cart (including payment widgets).
          try {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' } });
            if (cartResponse.ok) document.dispatchEvent(new CustomEvent('cart:change', { detail: {
              cart: await cartResponse.json(), sectionId: sectionId
            }}));
          } catch (error) { console.error(error); }
        } catch (error) {
          const message = added ? this.dataset.refreshError : (error.message || this.dataset.error);
          const currentStatus = document.querySelector('.ra-page-rec-status') || document.getElementById('cart-live-region-text');
          if (currentStatus) currentStatus.textContent = message;
          // Never allow a second add when the first succeeded but rendering failed.
          if (added) button.dataset.raAdded = 'true';
        } finally {
          this.busy = false;
          this.querySelectorAll('[data-ra-add-variant]').forEach(el => { el.disabled = el.dataset.raAdded === 'true'; });
          button.removeAttribute('aria-busy');
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = this.dataset.raBlock
              ? Array.from(html.querySelectorAll('product-recommendations--single')).find(el => el.dataset.raBlock === this.dataset.raBlock)
              : html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
